export default class User {
  constructor(props) {
    Object.assign(this, props)

    const queryTable = []

    if (this.invited) {
      this.identifier = this.invited
      this.state = 'INVITED'
    }

    if (this.identifier) {
      this.identifierSearchTerm = this.identifier.toLowerCase()
      queryTable.push(this.identifierSearchTerm)
    }

    if (this.state) {
      this.stateLabel = `${this.state[0].toUpperCase()}${this.state
        .slice(1)
        .toLowerCase()}`
      queryTable.push(this.state.toLowerCase())
    }

    this.roleLabel = 'User'

    switch (this.role) {
      case 'ADMIN':
        this.roleLabel = 'Administrator'
        break
      case 'SUPER':
        this.roleLabel = 'Super User'
        break
    }

    if (this.roleLabel) {
      queryTable.push(this.roleLabel.toLowerCase())
    }

    this.queryTable = queryTable
  }
}
